var map = {
	"./de-DE/dataset-documents": 29444,
	"./en-US/dataset-documents": 107,
	"./es-ES/dataset-documents": 7194,
	"./fa-IR/dataset-documents": 35346,
	"./fr-FR/dataset-documents": 60582,
	"./hi-IN/dataset-documents": 54948,
	"./it-IT/dataset-documents": 45756,
	"./ja-JP/dataset-documents": 88475,
	"./ko-KR/dataset-documents": 44049,
	"./pl-PL/dataset-documents": 81274,
	"./pt-BR/dataset-documents": 13746,
	"./ro-RO/dataset-documents": 39580,
	"./ru-RU/dataset-documents": 63507,
	"./sl-SI/dataset-documents": 75763,
	"./th-TH/dataset-documents": 20930,
	"./tr-TR/dataset-documents": 21986,
	"./uk-UA/dataset-documents": 13324,
	"./vi-VN/dataset-documents": 13077,
	"./zh-Hans/dataset-documents": 51232,
	"./zh-Hant/dataset-documents": 45589
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 39732;